import { TApplicationState } from '../../types/redux';

export const selectUtm = (state: TApplicationState) => state.utm;
